// extracted by mini-css-extract-plugin
export default {"itemContainer":"ResumeItem_itemContainer__18eU1"};